import { Component, OnInit, Inject } from '@angular/core';
import { Router, RouterModule, Route } from '@angular/router';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';

import { AccountService } from '../../services/account/account.service';
import { AppService } from '../../services/common/app.service';

import { AppConfiguration } from '../../models/common/appConfiguration';
import { PageConfiguration } from '../../models/common/pageConfiguration';
import { Culture } from '../../models/common/culture';

import { ForbiddenViewComponent } from './forbiddenView.component';
import { TranslationService } from '../../services/common/translation.service';

@Component({
  selector: 'nav-menu',
  template: require('./../../templates/common/navmenu.component.html'),
  styles: [require('./../../styles/common/navmenu.component.css')],
  providers: [AccountService, AppService, TranslationService]
})
export class NavMenuComponent implements OnInit {
  isAuthenticated: boolean = false;
  config: AppConfiguration = {
    pages: new Array<PageConfiguration>()
  };
  navigationPages: Array<PageConfiguration> = new Array<PageConfiguration>();

  currentCulture: Culture;
  supportedCultures: Array<Culture> = new Array<Culture>();

  constructor(private accountService: AccountService, private appService: AppService, private router: Router, private translationService: TranslationService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService) {
    this.currentCulture = TranslationService.currentCulture;
    this.resolveCulture();
  }

  ngOnInit() {
    this.accountService.isAuthenticated(userInfo => {
      this.isAuthenticated = userInfo.isAuthenticated;

      this.appService.loadConfiguration(config => {
        this.navigationPages.length = 0;
        this.config = config;
        this.filterNavigationPages();
        this.fillRoutes();
        this.checkCurrentPage();
      });
    });
  }

  resolveCulture() {
    this.loadSupportedCultures();

    if (TranslationService.explicitCulture) {
      this.switchLanguage(TranslationService.explicitCulture, false);
    }
    else if (this.storage.get("culture") == null) {
      if (TranslationService.isDefaultCultureEmpty()) {
        this.translationService.setDefaultCulture(culture => {
          this.switchLanguage(culture, false);
        });
      }
    } else {
      this.switchLanguage(this.storage.get("culture"), false);
      this.currentCulture = TranslationService.currentCulture;
    }
  }

  isPageVisible(page: PageConfiguration) {
    return !page.isDisabled &&
      page.isVisibleInMenu && (page.isPublic || (!page.isPublic && this.isAuthenticated));
  }

  filterNavigationPages() {
    this.config.pages.forEach(x => {

      if (this.isPageVisible(x)) {
        this.translationService.translate(`nav.${x.pageUrl}`, x.title, (data) => x.translatedTitle = data);
        this.navigationPages.push(x);
      }
    });
  }

  fillRoutes() {
    this.config.pages.forEach(x => {
      if (x.isClientRoute) {
        if (x.isDisabled) {
          this.router.config.unshift({
            path: x.pageUrl, component: ForbiddenViewComponent
          });
        } else {
          var route = this.router.config.find(p => p.path === x.pageUrl);
          if (route != undefined && route.data != undefined) {
            route.data.title = x.pageTitle;
          }
        }
      }
    });
  }

  checkCurrentPage() {
    var pageConfig = this.config.pages.find(p => this.router.url.indexOf(p.pageUrl) >= 0);
    if (pageConfig != undefined && pageConfig.isDisabled && this.router.url !== '/page-not-found') {
      this.router.navigate(['page-not-found']);
    }
  }

  switchLanguage(culture: Culture, reload: boolean) {
    this.storage.set("culture", culture);
    this.currentCulture = culture;
    if (culture.code !== TranslationService.currentCulture.code) {
      TranslationService.currentCulture = culture;
      if (reload) {
        window.location.href = window.location + this.joinMark(window.location) + "culture=" + culture.code;
      }
    }
  }

  joinMark(location: Location): string {
    if (location.pathname.indexOf('?') >= 0) return '&';
    return '?';
  }


  loadSupportedCultures() {
    this.translationService.getSupportedCultures(cultures => {
      this.supportedCultures = cultures;
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/common/navmenu.component.ts